export enum OrderByType {
	ascending = "ascending",
	descending = "descending",
}
